import React, { useState, useEffect } from 'react';
import { subscribeToPush, getNotificationPermission, isPushSupported } from './pushNotifications';
import theme from './theme';

const DISMISS_KEY = 'jobbetty_push_banner_dismissed';

function PushPermissionBanner({ session }) {
  const [visible, setVisible] = useState(false);
  const [asking, setAsking] = useState(false);

  useEffect(() => {
    if (!session) return;
    if (!isPushSupported()) return;
    const dismissed = localStorage.getItem(DISMISS_KEY);
    const permission = getNotificationPermission();
    if (permission === 'default' && !dismissed) {
      setVisible(true);
    }
  }, [session]);

  const handleEnable = async () => {
    setAsking(true);
    const result = await subscribeToPush(session.user.id);
    setAsking(false);
    setVisible(false);
    if (!result.success && result.reason === 'denied') {
      localStorage.setItem(DISMISS_KEY, 'true');
    }
  };

  const handleDismiss = () => {
    localStorage.setItem(DISMISS_KEY, 'true');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 76, left: '50%', transform: 'translateX(-50%)',
      width: 'calc(100% - 32px)', maxWidth: theme.layout.maxWidth - 32,
      background: theme.colors.white, borderRadius: theme.radius.lg,
      boxShadow: theme.shadow.floating, border: `1px solid ${theme.colors.border}`,
      padding: theme.spacing.lg, zIndex: 900,
    }}>
      <div style={{ display: 'flex', gap: theme.spacing.md, alignItems: 'flex-start' }}>
        <span style={{ fontSize: 24, flexShrink: 0 }}>🔔</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, fontSize: theme.font.size.md, color: theme.colors.textPrimary, marginBottom: 4 }}>
            Attiva le notifiche
          </div>
          <div style={{ fontSize: theme.font.size.sm, color: theme.colors.textSecondary, lineHeight: 1.4 }}>
            Ricevi subito un avviso per nuovi messaggi, candidature e recensioni.
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', gap: theme.spacing.sm, marginTop: theme.spacing.md }}>
        <button onClick={handleDismiss} style={{
          flex: 1, background: 'none', border: `1px solid ${theme.colors.border}`,
          color: theme.colors.textSecondary, borderRadius: theme.radius.sm, padding: 10,
          fontSize: theme.font.size.sm, cursor: 'pointer',
        }}>Non ora</button>
        <button onClick={handleEnable} disabled={asking} style={{
          flex: 2, background: theme.colors.primary, color: theme.colors.white, border: 'none',
          borderRadius: theme.radius.sm, padding: 10, fontSize: theme.font.size.sm, fontWeight: 600,
          cursor: asking ? 'not-allowed' : 'pointer',
        }}>{asking ? 'Attendi...' : 'Attiva notifiche'}</button>
      </div>
    </div>
  );
}

export default PushPermissionBanner;